// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fbf06633","949":"75a43d1a"}[chunkId] + ".chunk.js";
};